export const STATUS_APURACAO_OPTS = [
  { value: "", label: "Todos" },
  { value: "sucesso", label: "Concluído" },
  { value: "divergencia", label: "Divergência" },
  { value: "processando", label: "Em processamento" },
  { value: "erro", label: "Erro" },
  { value: "pendente", label: "Pendente" },
  { value: "cancelado", label: "Cancelado" },
];

export const STATUS_APURACAO = {
  pendente: { label: "Pendente", bgcolor: "#fff3e0", color: "#e65100" },
  processando: { label: "Em processamento", bgcolor: "#e3f2fd", color: "#1565c0" },
  sucesso: { label: "Concluído", bgcolor: "#e8f5e9", color: "#2e7d32" },
  /** TXM-325 item 07 — jobs OK + sumarização OK, mas regra de negócio violada (duplicidade/zero_registros). */
  divergencia: { label: "Divergência", bgcolor: "#fff8e1", color: "#8d6e00" },
  erro: { label: "Erro", bgcolor: "#ffebee", color: "#c62828" },
  /** Backend permite este status (ver STATUS_INDISPONIVEL/CHECK constraint em api-relatorios) —
   * antes desta correção o front caía no fallback de "pendente" (STATUS_APURACAO[status] ||
   * STATUS_APURACAO.pendente) e mostrava rótulo/cor errados pra uma apuração cancelada. */
  cancelado: { label: "Cancelado", bgcolor: "#eceff1", color: "#455a64" },
};

/** Ciclo da sumarização (sumarizacaoStatus) — hints na listagem. */
export const STATUS_SUMARIZACAO_HINT = {
  pendente: "Aguardando conclusão da apuração",
  processando: "Sumarização em processamento",
  erro: "Sumarização com erro — use Processar para tentar novamente",
};

export const MESES = [
  ["01", "Janeiro"],
  ["02", "Fevereiro"],
  ["03", "Março"],
  ["04", "Abril"],
  ["05", "Maio"],
  ["06", "Junho"],
  ["07", "Julho"],
  ["08", "Agosto"],
  ["09", "Setembro"],
  ["10", "Outubro"],
  ["11", "Novembro"],
  ["12", "Dezembro"],
];
